<template>
  <div class="dashboard">
    <dashboard-header></dashboard-header>
    <div class="half">
      <dashboard-nav class="nav"></dashboard-nav>
      <dashboard-main class="main"></dashboard-main>
    </div>
  </div>
</template>

<script>
  import DashboardHeader from '../UI/DashboardHeader.vue'
  import DashboardNav from '../UI/DashboardNav.vue'
  import DashboardMain from '../UI/DashboardMain.vue'
  
  export default {
    components: {
      DashboardHeader,
      DashboardNav,
      DashboardMain
    },
    computed: {
      fullName() {
        return this.$store.getters['user/getFullName']
      }
    },
  }
</script>

<style scoped>
  .dashboard {
    width: 100vw;
    /* background: linear-gradient(to bottom right, #00aba2 0%, #018e1b 100%); */
    max-height: 100vh;
    background: #e5e3cb
  }
  .half {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 80vh;
  }
  .nav {
    width: 15%;
  }
  .main {
    width: 85%;
  }
</style>